export const LOGIN = '/login';
export const LOGIN_ADAL = '/login/adal/';
export const HOME = '/';

// Home Tabs
export const FORMS = '/forms';
export const EQUIPMENTS = '/equipments';
export const INBOXES = '/inboxes';
export const EQUIPMENT = '/equipments/:schemaId/:entityId';
export const DECLARATIONS = '/declarations';
export const USER_SETTING = '/utilisateur';

// Others
export const QRSCAN = `/scan`;
export const FORM = `${FORMS}/:formId`;
export const NEW_DECLARATION = `${FORM}/declaration`;
export const NEW_DECLARATION_WITH_EQUIPMENT = `${FORM}/entity/:entityInstanceId`;
export const DECLARATION = `${FORM}/declaration/:declarationId`;
export const NEW_DECLARATION_FROM_DUPLICATION = `${DECLARATION}/duplicate`;
export const DECLARATION_FROM_INBOX = `${FORM}/inbox/:inboxId/:activityId`;
export const DECLARATION_HISTORY = `${DECLARATIONS}/anciennes`;
export const EQUIPMENT_DECLARATION_HISTORY = `${EQUIPMENT}/anciennes`;
export const MODULE_CHOICE = '/module';

// Deep Link
export const DEEP_LINK = '/deeplink';

// Common
export const ERROR = '/error';

// Module Param Chantier
export const MODULE_PARAM_WORK_SITE = '/moduleWorkSite';

export const WORK_SITE_SELECT = `${MODULE_PARAM_WORK_SITE}`;
export const WORK_SITE_SUMMARY = `${MODULE_PARAM_WORK_SITE}/site/:workSiteId`;
export const WORK_SITE_SUMMARY_USERS = `${WORK_SITE_SUMMARY}/users`;
export const WORK_SITE_SUMMARY_WBS = `${WORK_SITE_SUMMARY}/wbs`;
export const WORK_SITE_SUMMARY_PACK = `${WORK_SITE_SUMMARY}/:packId`;
export const WORK_SITE_SUMMARY_TEAM = `${WORK_SITE_SUMMARY}/team`;
